import React from 'react';
import clsx from 'clsx';

import scss from './StoryButton.module.scss';

function StoryButton({ icon: Icon, onClick, ariaLabel, className, size = 'md', disabled = false }) {
  const handleClick = (event) => {
    if (disabled) return;

    event.stopPropagation();
    onClick?.(event);
  };

  return (
    <button
      type='button'
      className={clsx(scss.button, scss[size], className)}
      onClick={handleClick}
      aria-label={ariaLabel}
      disabled={disabled}>
      <Icon className={scss.icon} />
    </button>
  );
}

export default StoryButton;
